<template>
  <div class="page-container">
    <div
      class="row no-gutters border rounded overflow-hidden flex-md-row mb-4 p-4 shadow-sm h-md-250 position-relative"
    >
      <b-form @submit.prevent="onSubmit" class="col-12">
        <h5>
          Dane organizacji
          <small><b-badge variant="danger">Widoczne na dokumentach rozliczeniowych</b-badge></small>
        </h5>
        <hr />
        <div class="row">
          <b-form-group
            id="input-group-name"
            label="Pełna nazwa organizacji:"
            label-for="input-name"
            description="Nazwa ta będzie widniała na ewentualnych dokumentach rozliczeniowych"
            class="col-12"
          >
            <b-form-input
              id="input-name"
              v-model="form.name"
              type="text"
              required
              placeholder="Wpisz nazwę organizacji"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-regon"
            label="REGON:"
            label-for="input-regon"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-regon"
              v-model="form.regon"
              type="text"
              required
              placeholder="Wpisz REGON"
              minLength="8"
              maxLength="14"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-nip"
            label="NIP:"
            label-for="input-nip"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-nip"
              v-model="form.nip"
              type="text"
              required
              placeholder="Wpisz NIP"
              v-mask="'##########'"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-3">
            Dane adresowe
            <small
              ><b-badge variant="danger">Widoczne na dokumentach rozliczeniowych</b-badge></small
            >
            <hr />
          </h5>
          <b-form-group
            id="input-group-address"
            label="Ulica wraz z numerem budynku oraz lokalu:"
            label-for="input-address"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-address"
              v-model="form.address"
              type="text"
              required
              placeholder="Wpisz ulicę wraz z numerem budynku oraz lokalu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-postal-code"
            label="Kod pocztowy:"
            label-for="input-posta-code"
            description=""
            class="col-2"
          >
            <b-form-input
              id="input-postal-code"
              v-model="form.postalCode"
              type="tel"
              required
              placeholder="Wpisz kod pocztowy"
              v-mask="'##-###'"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-city"
            label="Miasto:"
            label-for="input-city"
            description=""
            class="col-4"
          >
            <b-form-input
              id="input-city"
              v-model="form.city"
              type="text"
              required
              placeholder="Wpisz miasto"
            ></b-form-input>
          </b-form-group>
          <h5 class="col-12 mt-3">
            Informacje rozliczeniowe
            <hr />
          </h5>
          <b-form-group
            id="input-group-iban"
            label="Numer konta:"
            label-for="input-iban"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-iban"
              v-model="form.iban"
              type="text"
              required
              placeholder="Wpisz numer konta"
              v-mask="'## #### #### #### #### #### ####'"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-document"
            label="Dokument rozliczeniowy:"
            label-for="input-document"
            description=""
            class="col-6"
          >
            <b-form-select
              id="input-document"
              v-model="form.invoiceDocumentId"
              :options="invoiceDocuments"
              required
            ></b-form-select>
            <!-- TUTAJ CENY POWODÓW WIZYT -->
          </b-form-group>
          <h5 class="col-12 mt-3">
            Obszar działalności
            <hr />
          </h5>
          <b-form-group
            id="input-group-api_key"
            label="Lokalizacje:"
            label-for="input-scopes"
            :description="scopes"
            class="col-12"
          >
            <tags-input
              input-id="input-scopes"
              v-model="form.apiKeys"
              :existing-tags="allowedApiKeys"
              :typeahead-hide-discard="true"
              :typeahead="true"
              placeholder="Wpisz nazwę lokalizacji"
              :only-existing-tags="onlyExistingTags"
              :limit="limit"
            >
            </tags-input>
          </b-form-group>
          <h5 class="col-12 mt-3">
            Administrator
            <hr />
          </h5>
          <b-form-group
            id="input-group-admin-name"
            label="Imię:"
            label-for="input-admin-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-name"
              v-model="form.adminName"
              type="text"
              required
              placeholder="Wpisz imię administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-admin-last-name"
            label="Nazwisko:"
            label-for="input-admin-last-name"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-last-name"
              v-model="form.adminLastName"
              type="text"
              required
              placeholder="Wpisz nazwisko administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-admin-email"
            label="Adres email:"
            label-for="input-admin-email"
            description=""
            class="col-6"
          >
            <b-form-input
              id="input-email"
              v-model="form.adminEmail"
              type="email"
              required
              placeholder="Wpisz adres email administratora"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            id="input-group-admin-phone"
            label="Numer telefonu:"
            label-for="input-admin-phone"
            description="Numer telefonu będzie wymagany przy logowaniu w celu odebrania kodu SMS. Z tego powodu musi to być numer komórkowy."
            class="col-6"
          >
            <b-form-input
              id="input-phone"
              v-model="form.adminPhone"
              type="tel"
              v-mask="'48 ### ### ###'"
              required
              placeholder="Wpisz numer telefonu administratora"
            ></b-form-input>
          </b-form-group>
          <div class="col-12 row">
            <div class="col-12">
              <b-button type="submit" variant="primary">Dodaj organizacje</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Create',
  created() {
    this.fetchScopes()
  },
  data() {
    return {
      form: {},
      invoiceDocuments: [1, 2],
      allowedApiKeys: [],
      onlyExistingTags: true,
      limit: 0,
      scopes: 'Dostępne do wyboru: '
    }
  },
  methods: {
    onSubmit() {
      const vm = this
      const fromData = { ...vm.form, api_keys: vm.form.api_keys.map(item => item.key) }
      vm.$http
        .post('e-zacma/organization/create', fromData)
        .then(() => {
          vm.$toast.success({
            title: 'Organizacja stworzona poprawnie'
          })
          vm.$router.push({ name: 'e-zacma-organizations' })
        })
        .catch(() => {
          vm.$error()
        })
    },
    fetchScopes() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const scopes = response.data
        let i = 0
        // eslint-disable-next-line no-restricted-syntax
        for (const scope of scopes) {
          // eslint-disable-next-line no-plusplus
          ++i
          vm.allowedApiKeys.push({ key: scope.api_key, value: scope.name })
          vm.scopes += scopes.length > i ? `${scope.name}, ` : scope.name
        }
        vm.limit = i
      })
    }
  }
}
</script>

<style scoped></style>
